import { useContext } from "react";
import { useLocation } from "react-router-dom";
import IncidentGeneralChart from "./Incidents/IncidentGeneralChart";
import PackagesPickupByDay from "./Packages/PackagesPickupByDay";
import PackagesPickupMonthByClient from './Packages/PackagesPickupMonthByClient';
import PackagesPickupMonthByLocker from './Packages/PackagesPickupMonthByLocker';
import PackagesPickupYearGlobal from "./Packages/PackagesPickupYearGlobal";
import PercentageOccupation from "./Packages/PercentageOccupation";
import AuthContext from "../../../../contexts/auth";
import ContentCard from "../../../../components/layout/ContentCard";
import styles from "./CounterInsights.module.css";
import { verifyAccessViewPermissions } from "../../../../config/permissions";

const CounterStats = (props) => {
    const userContext = useContext(AuthContext);
    const location = useLocation();
    const { yearSelect, canReadFilters: canReadFiltersProp } = props;
    const permissionsPath = "/dashboard/insights";
    const canReadFilters = Boolean(canReadFiltersProp);

    const canReadPackagesPickedupByClient = verifyAccessViewPermissions(
      ["read-packages-pickedup-by-client"],
      { path: permissionsPath || location.pathname }
    );
    const canReadPackagesPickedupByLocker = verifyAccessViewPermissions(
      ["read-packages-pickedup-by-locker"],
      { path: permissionsPath || location.pathname }
    );
    const canReadPackagesPickedupByYear = verifyAccessViewPermissions(
      ["read-packages-pickedup-by-year"],
      { path: permissionsPath || location.pathname }
    );
    const canReadPackagesPickedupByDay = verifyAccessViewPermissions(
      ["read-packages-pickedup-by-day"],
      { path: permissionsPath || location.pathname }
    );
    const canReadIncidentsStatistics = verifyAccessViewPermissions(
      ["read-incidents-statistics"],
      { path: permissionsPath || location.pathname }
    );
    const canReadPercentageTotalOccupation = verifyAccessViewPermissions(
      ["read-percentage-total-occupation"],
      { path: permissionsPath || location.pathname }
    );

    return (
        <div className={styles.grid}>
            {canReadPackagesPickedupByClient && (
              <div className={styles.gridItem}>
                  <ContentCard padding="md">
                      <PackagesPickupMonthByClient yearSelect={yearSelect} user={userContext.user} canReadFilters={canReadFilters} />
                  </ContentCard>
              </div>
            )}

            {canReadPackagesPickedupByLocker && (
              <div className={styles.gridItem}>
                  <ContentCard padding="md">
                      <PackagesPickupMonthByLocker yearSelect={yearSelect} user={userContext.user} canReadFilters={canReadFilters} />
                  </ContentCard>
              </div>
            )}

            {canReadPackagesPickedupByYear && (
              <div className={styles.gridItem}>
                  <ContentCard padding="md">
                      <PackagesPickupYearGlobal yearSelect={yearSelect} user={userContext.user} canReadFilters={canReadFilters} />
                  </ContentCard>
              </div>
            )}

            {canReadPackagesPickedupByDay && (
              <div className={styles.gridItem}>
                  <ContentCard padding="md">
                      <PackagesPickupByDay yearSelect={yearSelect} user={userContext.user} canReadFilters={canReadFilters} />
                  </ContentCard>
              </div>
            )}

            {canReadIncidentsStatistics && (
              <div className={styles.gridItemFull}>
                  <ContentCard padding="md">
                      <IncidentGeneralChart yearSelect={yearSelect} canReadFilters={canReadFilters} />
                  </ContentCard>
              </div>
            )}

            {canReadPercentageTotalOccupation && (
              <div className={styles.gridItem}>
                  <ContentCard padding="md">
                      <PercentageOccupation yearSelect={yearSelect} canReadFilters={canReadFilters} />
                  </ContentCard>
              </div>
            )}
        </div>
    );
};

export default CounterStats;